import React from 'react'
import { initializeApollo } from 'gql/client'
import { GIGYA_BRAND, PAGINA } from 'utils/queries'
import LandingTemplate from '@components/templates/LandingTemplate/LandingTemplate'
import { NextWrapper } from 'data-fetching-wrapper'

const NewsletterBrandPage = ({ pagina, brand }) => (
  <LandingTemplate pagina={pagina} brand={brand} preferenzeOpen={false} />
)

export const getStaticPaths = NextWrapper.getStaticPaths(async () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}, '/newsletter/[slug]')

export const getStaticProps = NextWrapper.getStaticProps(async ({ params }) => {
  const slugParam = params?.slug
  const domain = (Array.isArray(slugParam) ? slugParam.join('/') : slugParam || '').toLowerCase()
  const allowedDomains = ['alpro', 'activia']
  //TODO: aggiunto controllo perchè si va live in maniera incremntale
  if (!domain || !allowedDomains.includes(domain)) {
    return {
      notFound: true,
    }
  }

  const client = initializeApollo()

  const {
    data: { brand },
  } = await client.query({
    query: GIGYA_BRAND,
    variables: { domain },
  })

  if (!brand) {
    return {
      notFound: true,
    }
  }



  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { chiave: 'newsletter-detail' },
  })


  return {
    props: { pagina: pagina || null, brand },
    revalidate: 60 * 2,
  }
}, '/newsletter/[slug]')

export default NewsletterBrandPage
